import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import ScrollToTop from "./ScrollToTop";
import CookieBanner from "@/components/legal/CookieBanner";

export default function PublicLayout() {
    return (
        <div className="min-h-screen bg-white flex flex-col">
            <ScrollToTop />
            <Header />
            <main className="flex-1 pt-16 md:pt-20 pb-20 md:pb-0">
                <Outlet />
            </main>
            <Footer />
            <StickyMobileCTA />
            <CookieBanner />
        </div>
    );
}
